/**
 * Тип для чего требуется получение обратного номера
 */
export enum FlashcallTypeEnum {
  CONFIRM_PHONE = 'CONFIRM_PHONE',
  RECOVERY_PASSWORD = 'RECOVERY_PASSWORD',
  CONFIRM_USERINFO = 'CONFIRM_USERINFO',
}
